"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("../util");
var common_1 = require("./common");
exports.defaultOptions = {
    bridgeSchema: 'didibridge://BRIDGE_CALL?callback=',
    bridgeCallDataName: '__getCallData__',
    bridgeCallbackName: '__bridgeCall__'
};
var msgFrame = null;
var msgId = 0;
function send(src) {
    if (!msgFrame) {
        msgFrame = util_1.createFrame(src, 'mfe-webview-util-iframe');
    }
    else {
        msgFrame.src = src;
    }
}
function schema(app, options) {
    options = __assign({}, exports.defaultOptions, options);
    var cmnID = util_1.randomId();
    return function (method, params, callback) {
        if (callback === void 0) { callback = util_1.noop; }
        msgId++;
        var msgCode = cmnID + "_" + msgId;
        var callbackName = callback._isCached
            ? options.bridgeCallbackName + "_" + method
            : options.bridgeCallbackName + "_" + msgCode + "_" + method;
        var callDataName = "" + options.bridgeCallDataName + msgCode;
        var callData = JSON.stringify({
            cmd: method,
            method: method,
            id: msgCode,
            params: params,
            callback: callbackName
        });
        window[callDataName] = function () {
            delete window[callDataName];
            return callData;
        };
        window[callbackName] = function (data) {
            if (!callback._isCached) {
                delete window[callbackName];
            }
            callback(data);
            try {
                util_1.logger({
                    pos: 'COMMUNICATION_SCHEMA_RES',
                    id: msgCode,
                    method: method,
                    params: JSON.stringify(data)
                });
            }
            catch (e) { }
        };
        send("" + options.bridgeSchema + callDataName);
        util_1.logger({
            pos: 'COMMUNICATION_SCHEMA',
            id: msgCode,
            method: method,
            params: callData
        });
    };
}
exports.default = common_1.createCommunicationFactory(schema, 'schema');
